"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        "index": 79,
        "rank": "SR",
        "name": "桃花妖",
        "atk": 2385.2,
        "hp": 11393,
        "def": 489.51,
        "spd": 100,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "生命加成+10%",
        "atk_pt": 89,
        "hp_pt": 100,
        "def_pt": 111,
        "total_pt": 300,
        "name_jp": "桃の精",
        "name_en": "Momo",
        "name_roma": "momo no sei",
        "name_kana": "もものせい",
        "id": 200,
        "no": 200
    },
    {
        "index": 78,
        "rank": "SR",
        "name": "雪女",
        "atk": 3055.2,
        "hp": 10481.64,
        "def": 414.54,
        "spd": 109,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 114,
        "hp_pt": 92,
        "def_pt": 94,
        "total_pt": 300,
        "name_jp": "雪女",
        "name_en": "Yuki Onna",
        "name_roma": "yuki onna",
        "name_kana": "ゆきおんな",
        "id": 201,
        "no": 201
    },
    {
        "index": 115,
        "rank": "R",
        "name": "三尾狐",
        "atk": 2921.2,
        "hp": 10367.72,
        "def": 441,
        "spd": 102,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "速度+20",
        "atk_pt": 109,
        "hp_pt": 91,
        "def_pt": 100,
        "total_pt": 300,
        "name_jp": "三尾の狐",
        "name_en": "Mio",
        "name_roma": "sanbi no kitsune",
        "name_kana": "さんびのきつね",
        "id": 202,
        "no": 202
    },
    {
        "index": 141,
        "rank": "N",
        "name": "灯笼鬼",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "提灯お化け",
        "name_en": "Lantern Soul",
        "name_roma": "chouchin obake",
        "name_kana": "ちょうちんおばけ",
        "id": 203,
        "no": 203
    },
    {
        "index": 114,
        "rank": "R",
        "name": "座敷童子",
        "atk": 2331.6,
        "hp": 12418.28,
        "def": 458.64,
        "spd": 102,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 87,
        "hp_pt": 109,
        "def_pt": 104,
        "total_pt": 300,
        "name_jp": "座敷童子",
        "name_en": "Zashiki",
        "name_roma": "zashiki warashi",
        "name_kana": "ざしきわらし",
        "id": 205,
        "no": 205
    },
    {
        "index": 113,
        "rank": "R",
        "name": "鲤鱼精",
        "atk": 2733.6,
        "hp": 11620.84,
        "def": 423.36,
        "spd": 117,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 102,
        "hp_pt": 102,
        "def_pt": 96,
        "total_pt": 300,
        "name_jp": "鯉の精",
        "name_en": "Koi",
        "name_roma": "koi no sei",
        "name_kana": "こいのせい",
        "id": 206,
        "no": 206
    },
    {
        "index": 112,
        "rank": "R",
        "name": "九命猫",
        "atk": 2974.8,
        "hp": 9798.12,
        "def": 454.23,
        "spd": 108,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 111,
        "hp_pt": 86,
        "def_pt": 103,
        "total_pt": 300,
        "name_jp": "九命猫",
        "name_en": "Kyuumei Neko",
        "name_roma": "kyuumei neko",
        "name_kana": "きゅうめいねこ",
        "id": 207,
        "no": 207
    },
    {
        "index": 111,
        "rank": "R",
        "name": "狸猫",
        "atk": 2358.4,
        "hp": 12873.96,
        "def": 436.59,
        "spd": 109,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 88,
        "hp_pt": 113,
        "def_pt": 99,
        "total_pt": 300,
        "name_jp": "化け狸",
        "name_en": "Tanuki",
        "name_roma": "bake tanuki",
        "name_kana": "ばけたぬき",
        "id": 208,
        "no": 208
    },
    {
        "index": 110,
        "rank": "R",
        "name": "河童",
        "atk": 3028.4,
        "hp": 10139.88,
        "def": 432.18,
        "spd": 113,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 113,
        "hp_pt": 89,
        "def_pt": 98,
        "total_pt": 300,
        "name_jp": "河童",
        "name_en": "Kappa",
        "name_roma": "kappa",
        "name_kana": "かっぱ",
        "id": 209,
        "no": 209
    },
    {
        "index": 77,
        "rank": "SR",
        "name": "鬼使白",
        "atk": 3055.2,
        "hp": 10253.8,
        "def": 423.36,
        "spd": 116,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 114,
        "hp_pt": 90,
        "def_pt": 96,
        "total_pt": 300,
        "name_jp": "白無常",
        "name_en": "Shiro Mujou",
        "name_roma": "shiro mujou",
        "name_kana": "しろむじょう",
        "id": 210,
        "no": 210
    },
    {
        "index": 76,
        "rank": "SR",
        "name": "鬼使黑",
        "atk": 3108.8,
        "hp": 10367.72,
        "def": 410.13,
        "spd": 101,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "攻击加成+10%",
        "atk_pt": 116,
        "hp_pt": 91,
        "def_pt": 93,
        "total_pt": 300,
        "name_jp": "黒無常",
        "name_en": "Kuro Mujou",
        "name_roma": "kuro mujou",
        "name_kana": "くろむじょう",
        "id": 211,
        "no": 211
    },
    {
        "index": 109,
        "rank": "R",
        "name": "童男",
        "atk": 2438.8,
        "hp": 12760.04,
        "def": 427.77,
        "spd": 103,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 91,
        "hp_pt": 112,
        "def_pt": 97,
        "total_pt": 300,
        "name_jp": "童男",
        "name_en": "Oguna",
        "name_roma": "oguna",
        "name_kana": "おぐな",
        "id": 212,
        "no": 212
    },
    {
        "index": 108,
        "rank": "R",
        "name": "童女",
        "atk": 2412,
        "hp": 12987.88,
        "def": 423.36,
        "spd": 109,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 90,
        "hp_pt": 114,
        "def_pt": 96,
        "total_pt": 300,
        "name_jp": "童女",
        "name_en": "Doujo",
        "name_roma": "doujo",
        "name_kana": "どうじょ",
        "id": 213,
        "no": 213
    },
    {
        "index": 107,
        "rank": "R",
        "name": "饿鬼",
        "atk": 2840.8,
        "hp": 11393,
        "def": 414.54,
        "spd": 105,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 106,
        "hp_pt": 100,
        "def_pt": 94,
        "total_pt": 300,
        "name_jp": "餓鬼",
        "name_en": "Gaki",
        "name_roma": "gaki",
        "name_kana": "がき",
        "id": 214,
        "no": 214
    },
    {
        "index": 75,
        "rank": "SR",
        "name": "孟婆",
        "atk": 2921.2,
        "hp": 10709.48,
        "def": 427.77,
        "spd": 115,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 109,
        "hp_pt": 94,
        "def_pt": 97,
        "total_pt": 300,
        "name_jp": "孟婆",
        "name_en": "Mouba",
        "name_roma": "mouba",
        "name_kana": "もうば",
        "id": 215,
        "no": 215
    },
    {
        "index": 106,
        "rank": "R",
        "name": "巫蛊师",
        "atk": 3055.2,
        "hp": 10709.48,
        "def": 405.72,
        "spd": 105,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "效果命中+20%",
        "atk_pt": 114,
        "hp_pt": 94,
        "def_pt": 92,
        "total_pt": 300,
        "name_jp": "蠱毒師",
        "name_en": "Kodokushi",
        "name_roma": "kodokushi",
        "name_kana": "こどくし",
        "id": 216,
        "no": 216
    },
    {
        "index": 30,
        "rank": "SSR",
        "name": "大天狗",
        "atk": 3135.6,
        "hp": 10025.96,
        "def": 418.95,
        "spd": 110,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "攻击加成+10%",
        "atk_pt": 117,
        "hp_pt": 88,
        "def_pt": 95,
        "total_pt": 300,
        "name_jp": "大天狗",
        "name_en": "Ootengu",
        "name_roma": "ootengu",
        "name_kana": "おおてんぐ",
        "id": 217,
        "no": 217
    },
    {
        "index": 105,
        "rank": "R",
        "name": "鸦天狗",
        "atk": 2974.8,
        "hp": 10481.64,
        "def": 427.77,
        "spd": 111,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 111,
        "hp_pt": 92,
        "def_pt": 97,
        "total_pt": 300,
        "name_jp": "烏天狗",
        "name_en": "Karasu Tengu",
        "name_roma": "karasu tengu",
        "name_kana": "からすてんぐ",
        "id": 218,
        "no": 218
    },
    {
        "index": 29,
        "rank": "SSR",
        "name": "酒吞童子",
        "atk": 3135.6,
        "hp": 11165.16,
        "def": 374.85,
        "spd": 113,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "伤害减免+10%",
        "atk_pt": 117,
        "hp_pt": 98,
        "def_pt": 85,
        "total_pt": 300,
        "name_jp": "酒呑童子",
        "name_en": "Shuten Doji",
        "name_roma": "shuten douji",
        "name_kana": "しゅてんどうじ",
        "id": 219,
        "no": 219
    },
    {
        "index": 74,
        "rank": "SR",
        "name": "犬神",
        "atk": 3001.6,
        "hp": 10253.8,
        "def": 432.18,
        "spd": 109,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 112,
        "hp_pt": 90,
        "def_pt": 98,
        "total_pt": 300,
        "name_jp": "犬神",
        "name_en": "Inugami",
        "name_roma": "inugami",
        "name_kana": "いぬがみ",
        "id": 220,
        "no": 220
    },
    {
        "index": 104,
        "rank": "R",
        "name": "食发鬼",
        "atk": 2894.4,
        "hp": 10709.48,
        "def": 432.18,
        "spd": 118,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 108,
        "hp_pt": 94,
        "def_pt": 98,
        "total_pt": 300,
        "name_jp": "髪喰い",
        "name_en": "Kamikui",
        "name_roma": "kami kui",
        "name_kana": "かみくい",
        "id": 221,
        "no": 221
    },
    {
        "index": 103,
        "rank": "R",
        "name": "武士之灵",
        "atk": 3028.4,
        "hp": 10481.64,
        "def": 418.95,
        "spd": 110,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 113,
        "hp_pt": 92,
        "def_pt": 95,
        "total_pt": 300,
        "name_jp": "侍の霊",
        "name_en": "Warrior Soul",
        "name_roma": "samurai no rei",
        "name_kana": "さむらいのれい",
        "id": 222,
        "no": 222
    },
    {
        "index": 73,
        "rank": "SR",
        "name": "骨女",
        "atk": 2948,
        "hp": 9912.04,
        "def": 454.23,
        "spd": 107,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 110,
        "hp_pt": 87,
        "def_pt": 103,
        "total_pt": 300,
        "name_jp": "骨女",
        "name_en": "Hone Onna",
        "name_roma": "hone onna",
        "name_kana": "ほねおんな",
        "id": 223,
        "no": 223
    },
    {
        "index": 102,
        "rank": "R",
        "name": "雨女",
        "atk": 2251.2,
        "hp": 12304.36,
        "def": 476.28,
        "spd": 103,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 84,
        "hp_pt": 108,
        "def_pt": 108,
        "total_pt": 300,
        "name_jp": "雨女",
        "name_en": "Ame Onna",
        "name_roma": "ame onna",
        "name_kana": "あめおんな",
        "id": 224,
        "no": 224
    },
    {
        "index": 101,
        "rank": "R",
        "name": "跳跳弟弟",
        "atk": 3028.4,
        "hp": 10709.48,
        "def": 410.13,
        "spd": 104,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 113,
        "hp_pt": 94,
        "def_pt": 93,
        "total_pt": 300,
        "name_jp": "キョンシー弟",
        "name_en": "Kyonshi Ototo",
        "name_roma": "kyonshii otouto",
        "name_kana": "きょんしーおとうと",
        "id": 225,
        "no": 225
    },
    {
        "index": 100,
        "rank": "R",
        "name": "跳跳妹妹",
        "atk": 3055.2,
        "hp": 10937.32,
        "def": 396.9,
        "spd": 108,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 114,
        "hp_pt": 96,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "キョンシー妹",
        "name_en": "Kyonshi Imoto",
        "name_roma": "kyonshii imouto",
        "name_kana": "きょんしーいもうと",
        "id": 226,
        "no": 226
    },
    {
        "index": 99,
        "rank": "R",
        "name": "兵俑",
        "atk": 2385.2,
        "hp": 13329.64,
        "def": 414.54,
        "spd": 116,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "一技能增强",
        "atk_pt": 89,
        "hp_pt": 117,
        "def_pt": 94,
        "total_pt": 300,
        "name_jp": "兵傭",
        "name_en": "Samurai X",
        "name_roma": "heiyou",
        "name_kana": "へいよう",
        "id": 227,
        "no": 227
    },
    {
        "index": 98,
        "rank": "R",
        "name": "丑时之女",
        "atk": 2894.4,
        "hp": 11165.16,
        "def": 414.54,
        "spd": 117,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 108,
        "hp_pt": 98,
        "def_pt": 94,
        "total_pt": 300,
        "name_jp": "丑の刻参り",
        "name_en": "Ushi no Toki",
        "name_roma": "ushi no kokumairi",
        "name_kana": "うしのこくまいり",
        "id": 228,
        "no": 228
    },
    {
        "index": 97,
        "rank": "R",
        "name": "独眼小僧",
        "atk": 2519.2,
        "hp": 11734.76,
        "def": 454.23,
        "spd": 118,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 94,
        "hp_pt": 103,
        "def_pt": 103,
        "total_pt": 300,
        "name_jp": "一つ目小僧",
        "name_en": "Hitosume",
        "name_roma": "hitotsu me kozou",
        "name_kana": "ひとつめこぞう",
        "id": 230,
        "no": 230
    },
    {
        "index": 72,
        "rank": "SR",
        "name": "鬼女红叶",
        "atk": 2974.8,
        "hp": 10253.8,
        "def": 436.59,
        "spd": 114,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 111,
        "hp_pt": 90,
        "def_pt": 99,
        "total_pt": 300,
        "name_jp": "鬼女紅葉",
        "name_en": "Momiji",
        "name_roma": "kijo momiji",
        "name_kana": "きじょもみじ",
        "id": 231,
        "no": 231
    },
    {
        "index": 96,
        "rank": "R",
        "name": "铁鼠",
        "atk": 2921.2,
        "hp": 10709.48,
        "def": 427.77,
        "spd": 115,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 109,
        "hp_pt": 94,
        "def_pt": 97,
        "total_pt": 300,
        "name_jp": "鉄鼠",
        "name_en": "Tesso",
        "name_roma": "tesso",
        "name_kana": "てっそ",
        "id": 232,
        "no": 232
    },
    {
        "index": 71,
        "rank": "SR",
        "name": "跳跳哥哥",
        "atk": 3055.2,
        "hp": 10709.48,
        "def": 405.72,
        "spd": 119,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 114,
        "hp_pt": 94,
        "def_pt": 92,
        "total_pt": 300,
        "name_jp": "キョンシー兄",
        "name_en": "Kyonshi Ani",
        "name_roma": "kyonshii ani",
        "name_kana": "きょんしーあに",
        "id": 233,
        "no": 233
    },
    {
        "index": 95,
        "rank": "R",
        "name": "椒图",
        "atk": 2304.8,
        "hp": 12304.36,
        "def": 467.46,
        "spd": 117,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 86,
        "hp_pt": 108,
        "def_pt": 106,
        "total_pt": 300,
        "name_jp": "椒図",
        "name_en": "Shuzu",
        "name_roma": "shouzu",
        "name_kana": "しょうず",
        "id": 234,
        "no": 234
    },
    {
        "index": 94,
        "rank": "R",
        "name": "管狐",
        "atk": 3001.6,
        "hp": 10595.56,
        "def": 418.95,
        "spd": 108,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 112,
        "hp_pt": 93,
        "def_pt": 95,
        "total_pt": 300,
        "name_jp": "管狐",
        "name_en": "Kanko",
        "name_roma": "kudagitsune",
        "name_kana": "くだぎつね",
        "id": 236,
        "no": 236
    },
    {
        "index": 93,
        "rank": "R",
        "name": "山兔",
        "atk": 2894.4,
        "hp": 10709.48,
        "def": 432.18,
        "spd": 115,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 108,
        "hp_pt": 94,
        "def_pt": 98,
        "total_pt": 300,
        "name_jp": "山兎",
        "name_en": "Yamausagi",
        "name_roma": "yamausagi",
        "name_kana": "やまうさぎ",
        "id": 237,
        "no": 237
    },
    {
        "index": 92,
        "rank": "R",
        "name": "萤草",
        "atk": 2680,
        "hp": 11393,
        "def": 441,
        "spd": 103,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 100,
        "hp_pt": 100,
        "def_pt": 100,
        "total_pt": 300,
        "name_jp": "蛍草",
        "name_en": "Kusa",
        "name_roma": "hotarugusa",
        "name_kana": "ほたるぐさ",
        "id": 238,
        "no": 238
    },
    {
        "index": 91,
        "rank": "R",
        "name": "蝴蝶精",
        "atk": 2438.8,
        "hp": 12076.52,
        "def": 454.23,
        "spd": 115,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 91,
        "hp_pt": 106,
        "def_pt": 103,
        "total_pt": 300,
        "name_jp": "胡蝶の精",
        "name_en": "Chocho",
        "name_roma": "kochou no sei",
        "name_kana": "こちょうのせい",
        "id": 241,
        "no": 241
    },
    {
        "index": 70,
        "rank": "SR",
        "name": "傀儡师",
        "atk": 2840.8,
        "hp": 11734.76,
        "def": 401.31,
        "spd": 108,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 106,
        "hp_pt": 103,
        "def_pt": 91,
        "total_pt": 300,
        "name_jp": "傀儡師",
        "name_en": "Puppeteer",
        "name_roma": "kairaishi",
        "name_kana": "かいらいし",
        "id": 242,
        "no": 242
    },
    {
        "index": 90,
        "rank": "R",
        "name": "山童",
        "atk": 3001.6,
        "hp": 10139.88,
        "def": 436.59,
        "spd": 116,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "防御加成+20%",
        "atk_pt": 112,
        "hp_pt": 89,
        "def_pt": 99,
        "total_pt": 300,
        "name_jp": "山童",
        "name_en": "Yamawaro",
        "name_roma": "yamawaro",
        "name_kana": "やまわろ",
        "id": 243,
        "no": 243
    },
    {
        "index": 89,
        "rank": "R",
        "name": "首无",
        "atk": 2894.4,
        "hp": 10937.32,
        "def": 423.36,
        "spd": 110,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 108,
        "hp_pt": 96,
        "def_pt": 96,
        "total_pt": 300,
        "name_jp": "首なし",
        "name_en": "Kubinashi",
        "name_roma": "kubi nashi",
        "name_kana": "くびなし",
        "id": 244,
        "no": 244
    },
    {
        "index": 140,
        "rank": "N",
        "name": "提灯小僧",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "提灯小僧",
        "name_en": "Lantern Boy",
        "name_roma": "chouchin kozou",
        "name_kana": "ちょうちんこぞう",
        "id": 245,
        "no": 245
    },
    {
        "index": 139,
        "rank": "N",
        "name": "赤舌",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "赤舌",
        "name_en": "Akashita",
        "name_roma": "akajita",
        "name_kana": "あかじた",
        "id": 246,
        "no": 246
    },
    {
        "index": 69,
        "rank": "SR",
        "name": "海坊主",
        "atk": 3055.2,
        "hp": 10139.88,
        "def": 427.77,
        "spd": 109,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 114,
        "hp_pt": 89,
        "def_pt": 97,
        "total_pt": 300,
        "name_jp": "海坊主",
        "name_en": "Umibozu",
        "name_roma": "umi bouzu",
        "name_kana": "うみぼうず",
        "id": 247,
        "no": 247
    },
    {
        "index": 28,
        "rank": "SSR",
        "name": "荒川之主",
        "atk": 3001.6,
        "hp": 11051.24,
        "def": 401.31,
        "spd": 111,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "暴击+10%",
        "atk_pt": 112,
        "hp_pt": 97,
        "def_pt": 91,
        "total_pt": 300,
        "name_jp": "荒川の主",
        "name_en": "Lord Arakawa ",
        "name_roma": "arakawa no aruji",
        "name_kana": "あらかわのあるじ",
        "id": 248,
        "no": 248
    },
    {
        "index": 88,
        "rank": "R",
        "name": "觉",
        "atk": 2599.6,
        "hp": 11620.84,
        "def": 445.41,
        "spd": 108,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 97,
        "hp_pt": 102,
        "def_pt": 101,
        "total_pt": 300,
        "name_jp": "覚",
        "name_en": "Satori",
        "name_roma": "kaku",
        "name_kana": "かく",
        "id": 249,
        "no": 249
    },
    {
        "index": 87,
        "rank": "R",
        "name": "青蛙瓷器",
        "atk": 2974.8,
        "hp": 10595.56,
        "def": 423.36,
        "spd": 107,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 111,
        "hp_pt": 93,
        "def_pt": 96,
        "total_pt": 300,
        "name_jp": "磁器蛙",
        "name_en": "Jikikaeru",
        "name_roma": "jiki kaeru",
        "name_kana": "じきかえる",
        "id": 250,
        "no": 250
    },
    {
        "index": 68,
        "rank": "SR",
        "name": "判官",
        "atk": 3028.4,
        "hp": 10481.64,
        "def": 418.95,
        "spd": 118,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 113,
        "hp_pt": 92,
        "def_pt": 95,
        "total_pt": 300,
        "name_jp": "判官",
        "name_en": "Hangan",
        "name_roma": "hangan",
        "name_kana": "はんがん",
        "id": 251,
        "no": 251
    },
    {
        "index": 67,
        "rank": "SR",
        "name": "凤凰火",
        "atk": 2680,
        "hp": 11393,
        "def": 441,
        "spd": 106,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 100,
        "hp_pt": 100,
        "def_pt": 100,
        "total_pt": 300,
        "name_jp": "鳳凰火",
        "name_en": "Hououga",
        "name_roma": "hououka",
        "name_kana": "ほうおうか",
        "id": 252,
        "no": 252
    },
    {
        "index": 66,
        "rank": "SR",
        "name": "吸血姬",
        "atk": 3001.6,
        "hp": 10937.32,
        "def": 405.72,
        "spd": 115,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 112,
        "hp_pt": 96,
        "def_pt": 92,
        "total_pt": 300,
        "name_jp": "吸血姫",
        "name_en": "Vampira",
        "name_roma": "kyuuketsu hime",
        "name_kana": "きゅうけつひめ",
        "id": 253,
        "no": 253
    },
    {
        "index": 65,
        "rank": "SR",
        "name": "妖狐",
        "atk": 3055.2,
        "hp": 10367.72,
        "def": 418.95,
        "spd": 115,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "吸血+10%",
        "atk_pt": 114,
        "hp_pt": 91,
        "def_pt": 95,
        "total_pt": 300,
        "name_jp": "妖狐",
        "name_en": "Youko",
        "name_roma": "youko",
        "name_kana": "ようこ",
        "id": 254,
        "no": 254
    },
    {
        "index": 27,
        "rank": "SSR",
        "name": "阎魔",
        "atk": 2465.6,
        "hp": 11962.6,
        "def": 454.23,
        "spd": 117,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "速度+10",
        "atk_pt": 92,
        "hp_pt": 105,
        "def_pt": 103,
        "total_pt": 300,
        "name_jp": "閻魔",
        "name_en": "Enma",
        "name_roma": "enma",
        "name_kana": "えんま",
        "id": 255,
        "no": 255
    },
    {
        "index": 64,
        "rank": "SR",
        "name": "妖琴师",
        "atk": 2572.8,
        "hp": 12646.12,
        "def": 410.13,
        "spd": 120,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 96,
        "hp_pt": 111,
        "def_pt": 93,
        "total_pt": 300,
        "name_jp": "妖琴師",
        "name_en": "Maestro",
        "name_roma": "youkinshi",
        "name_kana": "ようきんし",
        "id": 256,
        "no": 256
    },
    {
        "index": 63,
        "rank": "SR",
        "name": "食梦貘",
        "atk": 2412,
        "hp": 11962.6,
        "def": 463.05,
        "spd": 119,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 90,
        "hp_pt": 105,
        "def_pt": 105,
        "total_pt": 300,
        "name_jp": "夢喰い",
        "name_en": "Yumekui",
        "name_roma": "yume kui",
        "name_kana": "ゆめくい",
        "id": 257,
        "no": 257
    },
    {
        "index": 26,
        "rank": "SSR",
        "name": "两面佛",
        "atk": 3135.6,
        "hp": 10481.64,
        "def": 401.31,
        "spd": 109,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "伤害加成+10%",
        "atk_pt": 117,
        "hp_pt": 92,
        "def_pt": 91,
        "total_pt": 300,
        "name_jp": "両面仏",
        "name_en": "Ryomen",
        "name_roma": "ryoumen botoke",
        "name_kana": "りょうめんぼとけ",
        "id": 258,
        "no": 258
    },
    {
        "index": 25,
        "rank": "SSR",
        "name": "小鹿男",
        "atk": 2814,
        "hp": 11165.16,
        "def": 427.77,
        "spd": 120,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 105,
        "hp_pt": 98,
        "def_pt": 97,
        "total_pt": 300,
        "name_jp": "シシオ",
        "name_en": "Shishio",
        "name_roma": "shishio",
        "name_kana": "ししお",
        "id": 259,
        "no": 259
    },
    {
        "index": 62,
        "rank": "SR",
        "name": "清姬",
        "atk": 2412,
        "hp": 11848.68,
        "def": 467.46,
        "spd": 105,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 90,
        "hp_pt": 104,
        "def_pt": 106,
        "total_pt": 300,
        "name_jp": "清姫",
        "name_en": "Kiyohime",
        "name_roma": "kiyo hime",
        "name_kana": "きよひめ",
        "id": 260,
        "no": 260
    },
    {
        "index": 61,
        "rank": "SR",
        "name": "镰鼬",
        "atk": 2680,
        "hp": 11620.84,
        "def": 432.18,
        "spd": 117,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 100,
        "hp_pt": 102,
        "def_pt": 98,
        "total_pt": 300,
        "name_jp": "鎌鼬",
        "name_en": "Kamaitachi",
        "name_roma": "kamaitachi",
        "name_kana": "かまいたち",
        "id": 261,
        "no": 261
    },
    {
        "index": 60,
        "rank": "SR",
        "name": "姑获鸟",
        "atk": 3082,
        "hp": 10823.4,
        "def": 396.9,
        "spd": 113,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "伤害加成+10%",
        "atk_pt": 115,
        "hp_pt": 95,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "姑獲鳥",
        "name_en": "Ubume",
        "name_roma": "ubume",
        "name_kana": "うぶめ",
        "id": 262,
        "no": 262
    },
    {
        "index": 59,
        "rank": "SR",
        "name": "二口女",
        "atk": 2626.4,
        "hp": 11506.92,
        "def": 445.41,
        "spd": 116,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 98,
        "hp_pt": 101,
        "def_pt": 101,
        "total_pt": 300,
        "name_jp": "二口女",
        "name_en": "Futakuchi",
        "name_roma": "hutakuchi onna",
        "name_kana": "ふたくちおんな",
        "id": 263,
        "no": 263
    },
    {
        "index": 58,
        "rank": "SR",
        "name": "白狼",
        "atk": 3082,
        "hp": 10823.4,
        "def": 396.9,
        "spd": 112,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 115,
        "hp_pt": 95,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "白狼",
        "name_en": "Hakuro",
        "name_roma": "hakurou",
        "name_kana": "はくろう",
        "id": 264,
        "no": 264
    },
    {
        "index": 24,
        "rank": "SSR",
        "name": "茨木童子",
        "atk": 3216,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 112,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 120,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "茨木童子",
        "name_en": "Ibaraki Doji",
        "name_roma": "ibaraki douji",
        "name_kana": "いばらきどうじ",
        "id": 265,
        "no": 265
    },
    {
        "index": 23,
        "rank": "SSR",
        "name": "青行灯",
        "atk": 2438.8,
        "hp": 11620.84,
        "def": 471.87,
        "spd": 119,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 91,
        "hp_pt": 102,
        "def_pt": 107,
        "total_pt": 300,
        "name_jp": "青行灯",
        "name_en": "Aoandon",
        "name_roma": "aoandon",
        "name_kana": "あおあんどん",
        "id": 266,
        "no": 266
    },
    {
        "index": 57,
        "rank": "SR",
        "name": "樱花妖",
        "atk": 2385.2,
        "hp": 13785.32,
        "def": 396.9,
        "spd": 99,
        "cri": 0.03,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 89,
        "hp_pt": 121,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "桜の精",
        "name_en": "Sakura",
        "name_roma": "sakura no sei",
        "name_kana": "さくらのせい",
        "id": 267,
        "no": 267
    },
    {
        "index": 56,
        "rank": "SR",
        "name": "惠比寿",
        "atk": 2358.4,
        "hp": 12873.96,
        "def": 436.59,
        "spd": 107,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 88,
        "hp_pt": 113,
        "def_pt": 99,
        "total_pt": 300,
        "name_jp": "恵比寿",
        "name_en": "Ebisu",
        "name_roma": "ebisu",
        "name_kana": "えびす",
        "id": 268,
        "no": 268
    },
    {
        "index": 22,
        "rank": "SSR",
        "name": "妖刀姬",
        "atk": 3269.6,
        "hp": 10025.96,
        "def": 396.9,
        "spd": 111,
        "cri": 0.12,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 122,
        "hp_pt": 88,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "妖刀姫",
        "name_en": "Yoto Hime",
        "name_roma": "youtou hime",
        "name_kana": "ようとうひめ",
        "id": 269,
        "no": 269
    },
    {
        "index": 55,
        "rank": "SR",
        "name": "络新妇",
        "atk": 3216,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 112,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "攻击加成+10%",
        "atk_pt": 120,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "絡新婦",
        "name_en": "Jorogumo",
        "name_roma": "jorou gumo",
        "name_kana": "じょろうぐも",
        "id": 270,
        "no": 270
    },
    {
        "index": 54,
        "rank": "SR",
        "name": "般若",
        "atk": 3135.6,
        "hp": 10595.56,
        "def": 396.9,
        "spd": 114,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 117,
        "hp_pt": 93,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "般若",
        "name_en": "Hannya",
        "name_roma": "hannya",
        "name_kana": "はんにゃ",
        "id": 271,
        "no": 271
    },
    {
        "index": 21,
        "rank": "SSR",
        "name": "一目连",
        "atk": 2385.2,
        "hp": 13899.24,
        "def": 392.49,
        "spd": 117,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 89,
        "hp_pt": 122,
        "def_pt": 89,
        "total_pt": 300,
        "name_jp": "一目連",
        "name_en": "Ichimokuren",
        "name_roma": "ichimokuren",
        "name_kana": "いちもくれん",
        "id": 272,
        "no": 272
    },
    {
        "index": 53,
        "rank": "SR",
        "name": "青坊主",
        "atk": 2385.2,
        "hp": 13329.64,
        "def": 414.54,
        "spd": 118,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 89,
        "hp_pt": 117,
        "def_pt": 94,
        "total_pt": 300,
        "name_jp": "青坊主",
        "name_en": "Aobozu",
        "name_roma": "ao bouzu",
        "name_kana": "あおぼうず",
        "id": 273,
        "no": 273
    },
    {
        "index": 86,
        "rank": "R",
        "name": "古笼火",
        "atk": 2519.2,
        "hp": 13215.72,
        "def": 396.9,
        "spd": 117,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 94,
        "hp_pt": 116,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "古籠火",
        "name_en": "Koroka",
        "name_roma": "korouka",
        "name_kana": "ころうか",
        "id": 274,
        "no": 274
    },
    {
        "index": 52,
        "rank": "SR",
        "name": "万年竹",
        "atk": 3269.6,
        "hp": 10139.88,
        "def": 392.49,
        "spd": 115,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "攻击加成+10%",
        "atk_pt": 122,
        "hp_pt": 89,
        "def_pt": 89,
        "total_pt": 300,
        "name_jp": "万年竹",
        "name_en": "Mannendake",
        "name_roma": "mannen dake",
        "name_kana": "まんねんだけ",
        "id": 275,
        "no": 275
    },
    {
        "index": 51,
        "rank": "SR",
        "name": "夜叉",
        "atk": 3269.6,
        "hp": 10139.88,
        "def": 392.49,
        "spd": 110,
        "cri": 0.12,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 122,
        "hp_pt": 89,
        "def_pt": 89,
        "total_pt": 300,
        "name_jp": "夜叉",
        "name_en": "Yasha",
        "name_roma": "yasha",
        "name_kana": "やしゃ",
        "id": 276,
        "no": 276
    },
    {
        "index": 50,
        "rank": "SR",
        "name": "黑童子",
        "atk": 3376.8,
        "hp": 9912.04,
        "def": 383.67,
        "spd": 109,
        "cri": 0.09,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 126,
        "hp_pt": 87,
        "def_pt": 87,
        "total_pt": 300,
        "name_jp": "黒童子",
        "name_en": "Kuro",
        "name_roma": "kuro douji",
        "name_kana": "くろどうじ",
        "id": 277,
        "no": 277
    },
    {
        "index": 49,
        "rank": "SR",
        "name": "白童子",
        "atk": 3189.2,
        "hp": 10481.64,
        "def": 392.49,
        "spd": 113,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 119,
        "hp_pt": 92,
        "def_pt": 89,
        "total_pt": 300,
        "name_jp": "白童子",
        "name_en": "Shiro",
        "name_roma": "shiro douji",
        "name_kana": "しろどうじ",
        "id": 278,
        "no": 278
    },
    {
        "index": 20,
        "rank": "SSR",
        "name": "花鸟卷",
        "atk": 2304.8,
        "hp": 14127.08,
        "def": 396.9,
        "spd": 112,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 86,
        "hp_pt": 124,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "花鳥風月",
        "name_en": "Hana",
        "name_roma": "kachouhuugetsu",
        "name_kana": "かちょうふうげつ",
        "id": 279,
        "no": 279
    },
    {
        "index": 19,
        "rank": "SSR",
        "name": "辉夜姬",
        "atk": 2331.6,
        "hp": 13785.32,
        "def": 405.72,
        "spd": 108,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 87,
        "hp_pt": 121,
        "def_pt": 92,
        "total_pt": 300,
        "name_jp": "かぐや姫",
        "name_en": "Kaguya",
        "name_roma": "kaguya hime",
        "name_kana": "かぐやひめ",
        "id": 280,
        "no": 280
    },
    {
        "index": 48,
        "rank": "SR",
        "name": "烟烟罗",
        "atk": 3162.4,
        "hp": 10595.56,
        "def": 392.49,
        "spd": 112,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 118,
        "hp_pt": 93,
        "def_pt": 89,
        "total_pt": 300,
        "name_jp": "煙々羅",
        "name_en": "Enenra",
        "name_roma": "enenra",
        "name_kana": "えんえんら",
        "id": 281,
        "no": 281
    },
    {
        "index": 47,
        "rank": "SR",
        "name": "金鱼姬",
        "atk": 2331.6,
        "hp": 13671.4,
        "def": 410.13,
        "spd": 116,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 87,
        "hp_pt": 120,
        "def_pt": 93,
        "total_pt": 300,
        "name_jp": "金魚姫",
        "name_en": "Kingyo",
        "name_roma": "kingyo hime",
        "name_kana": "きんぎょひめ",
        "id": 282,
        "no": 282
    },
    {
        "index": 18,
        "rank": "SSR",
        "name": "荒",
        "atk": 3323.2,
        "hp": 10253.8,
        "def": 489.51,
        "spd": 104,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 124,
        "hp_pt": 90,
        "def_pt": 111,
        "total_pt": 325,
        "name_jp": "荒",
        "name_en": "Susabi",
        "name_roma": "susabi",
        "name_kana": "すさび",
        "id": 283,
        "no": 283
    },
    {
        "index": 46,
        "rank": "SR",
        "name": "鸩",
        "atk": 3001.6,
        "hp": 11393,
        "def": 388.08,
        "spd": 119,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 112,
        "hp_pt": 100,
        "def_pt": 88,
        "total_pt": 300,
        "name_jp": "鴆",
        "name_en": "Chin",
        "name_roma": "chin",
        "name_kana": "ちん",
        "id": 285,
        "no": 285
    },
    {
        "index": 45,
        "rank": "SR",
        "name": "以津真天",
        "atk": 3269.6,
        "hp": 10025.96,
        "def": 396.9,
        "spd": 110,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 122,
        "hp_pt": 88,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "以津真天",
        "name_en": "Itsumade",
        "name_roma": "itsumade",
        "name_kana": "いつまで",
        "id": 286,
        "no": 286
    },
    {
        "index": 44,
        "rank": "SR",
        "name": "匣中少女",
        "atk": 2438.8,
        "hp": 13671.4,
        "def": 392.49,
        "spd": 119,
        "cri": 0.03,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 91,
        "hp_pt": 120,
        "def_pt": 89,
        "total_pt": 300,
        "name_jp": "匣の少女",
        "name_en": "Hako Shoujo",
        "name_roma": "hako no shoujo",
        "name_kana": "はこのしょうじょ",
        "id": 287,
        "no": 287
    },
    {
        "index": 17,
        "rank": "SSR",
        "name": "彼岸花",
        "atk": 3001.6,
        "hp": 11393,
        "def": 388.08,
        "spd": 107,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 112,
        "hp_pt": 100,
        "def_pt": 88,
        "total_pt": 300,
        "name_jp": "彼岸花",
        "name_en": "Higanbana",
        "name_roma": "higanbana",
        "name_kana": "ひがんばな",
        "id": 288,
        "no": 288
    },
    {
        "index": 85,
        "rank": "R",
        "name": "兔丸",
        "atk": 2412,
        "hp": 13215.72,
        "def": 414.54,
        "spd": 116,
        "cri": 0.03,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 90,
        "hp_pt": 116,
        "def_pt": 94,
        "total_pt": 300,
        "name_jp": "兎丸",
        "name_en": "Usagi",
        "name_roma": "usagimaru",
        "name_kana": "うさぎまる",
        "id": 289,
        "no": 289
    },
    {
        "index": 43,
        "rank": "SR",
        "name": "小松丸",
        "atk": 2921.2,
        "hp": 10823.4,
        "def": 423.36,
        "spd": 115,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 109,
        "hp_pt": 95,
        "def_pt": 96,
        "total_pt": 300,
        "name_jp": "小松丸",
        "name_en": "Komatsu",
        "name_roma": "komatsumaru",
        "name_kana": "こまつまる",
        "id": 290,
        "no": 290
    },
    {
        "index": 42,
        "rank": "SR",
        "name": "书翁",
        "atk": 2680,
        "hp": 11393,
        "def": 441,
        "spd": 109,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 100,
        "hp_pt": 100,
        "def_pt": 100,
        "total_pt": 300,
        "name_jp": "書妖",
        "name_en": "Bukkuman",
        "name_roma": "shoyou",
        "name_kana": "しょよう",
        "id": 291,
        "no": 291
    },
    {
        "index": 16,
        "rank": "SSR",
        "name": "雪童子",
        "atk": 3323.2,
        "hp": 10025.96,
        "def": 388.08,
        "spd": 121,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 124,
        "hp_pt": 88,
        "def_pt": 88,
        "total_pt": 300,
        "name_jp": "雪童子",
        "name_en": "Yuki",
        "name_roma": "yuki douji",
        "name_kana": "ゆきどうじ",
        "id": 292,
        "no": 292
    },
    {
        "index": 41,
        "rank": "SR",
        "name": "百目鬼",
        "atk": 2733.6,
        "hp": 9456.36,
        "def": 507.15,
        "spd": 118,
        "cri": 0.03,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 102,
        "hp_pt": 83,
        "def_pt": 115,
        "total_pt": 300,
        "name_jp": "百目鬼",
        "name_en": "Dodomeki",
        "name_roma": "doumeki",
        "name_kana": "どうめき",
        "id": 293,
        "no": 293
    },
    {
        "index": 15,
        "rank": "SSR",
        "name": "奴良陆生",
        "atk": 3028.4,
        "hp": 11393,
        "def": 383.67,
        "spd": 113,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "效果抵抗+50%",
        "atk_pt": 113,
        "hp_pt": 100,
        "def_pt": 87,
        "total_pt": 300,
        "name_jp": "奴良リクオ",
        "name_en": "",
        "name_roma": "nura rikuo",
        "name_kana": "ぬらりくお",
        "id": 294,
        "no": 294
    },
    {
        "index": 40,
        "rank": "SR",
        "name": "追月神",
        "atk": 2304.8,
        "hp": 12760.04,
        "def": 449.82,
        "spd": 109,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 86,
        "hp_pt": 112,
        "def_pt": 102,
        "total_pt": 300,
        "name_jp": "追月神",
        "name_en": "Oitsuki",
        "name_roma": "oitsukigami",
        "name_kana": "おいつきがみ",
        "id": 295,
        "no": 295
    },
    {
        "index": 14,
        "rank": "SSR",
        "name": "山风",
        "atk": 3403.6,
        "hp": 11393,
        "def": 388.08,
        "spd": 115,
        "cri": 0.01,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 127,
        "hp_pt": 100,
        "def_pt": 88,
        "total_pt": 315,
        "name_jp": "山風",
        "name_en": "",
        "name_roma": "yamakaze",
        "name_kana": "やまかぜ",
        "id": 296,
        "no": 296
    },
    {
        "index": 39,
        "rank": "SR",
        "name": "日和坊",
        "atk": 2358.4,
        "hp": 14013.16,
        "def": 392.49,
        "spd": 112,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 88,
        "hp_pt": 123,
        "def_pt": 89,
        "total_pt": 300,
        "name_jp": "日和坊",
        "name_en": "Hiyoribou",
        "name_roma": "hiyoribou",
        "name_kana": "ひよりぼう",
        "id": 297,
        "no": 297
    },
    {
        "index": 38,
        "rank": "SR",
        "name": "薰",
        "atk": 2251.2,
        "hp": 13899.24,
        "def": 396.9,
        "spd": 111,
        "cri": 0.03,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 84,
        "hp_pt": 122,
        "def_pt": 90,
        "total_pt": 296,
        "name_jp": "薫",
        "name_en": "",
        "name_roma": "kaoru",
        "name_kana": "かおる",
        "id": 298,
        "no": 298
    },
    {
        "index": 13,
        "rank": "SSR",
        "name": "玉藻前",
        "atk": 3350,
        "hp": 12532.2,
        "def": 352.8,
        "spd": 110,
        "cri": 0.12,
        "cri_dmg": 1.6,
        "evolve": "忽视防御+100",
        "atk_pt": 125,
        "hp_pt": 110,
        "def_pt": 80,
        "total_pt": 315,
        "name_jp": "玉藻前",
        "name_en": "Tamamonomae",
        "name_roma": "tamamono mae",
        "name_kana": "たまものまえ",
        "id": 300,
        "no": 300
    },
    {
        "index": 84,
        "rank": "R",
        "name": "数珠",
        "atk": 2251.2,
        "hp": 11051.24,
        "def": 485.1,
        "spd": 111,
        "cri": 0.03,
        "cri_dmg": 1.5,
        "evolve": "效果抵抗+25%",
        "atk_pt": 84,
        "hp_pt": 97,
        "def_pt": 110,
        "total_pt": 291,
        "name_jp": "数珠",
        "name_en": "Juzu",
        "name_roma": "juzu",
        "name_kana": "じゅず",
        "id": 301,
        "no": 301
    },
    {
        "index": 83,
        "rank": "R",
        "name": "小袖之手",
        "atk": 2948,
        "hp": 11051.24,
        "def": 401.31,
        "spd": 116,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 110,
        "hp_pt": 97,
        "def_pt": 91,
        "total_pt": 298,
        "name_jp": "小袖の手",
        "name_en": "Kosodenote",
        "name_roma": "kosode no te",
        "name_kana": "こそでのて",
        "id": 302,
        "no": 302
    },
    {
        "index": 37,
        "rank": "SR",
        "name": "弈",
        "atk": 3001.6,
        "hp": 9912.04,
        "def": 445.41,
        "spd": 106,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 112,
        "hp_pt": 87,
        "def_pt": 101,
        "total_pt": 300,
        "name_jp": "棋聖",
        "name_en": "Kisei",
        "name_roma": "kisei",
        "name_kana": "きせい",
        "id": 303,
        "no": 303
    },
    {
        "index": 12,
        "rank": "SSR",
        "name": "御馔津",
        "atk": 3001.6,
        "hp": 12646.12,
        "def": 449.82,
        "spd": 119,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 112,
        "hp_pt": 111,
        "def_pt": 102,
        "total_pt": 325,
        "name_jp": "御饌津",
        "name_en": "",
        "name_roma": "miketsu",
        "name_kana": "みけつ",
        "id": 304,
        "no": 304
    },
    {
        "index": 11,
        "rank": "SSR",
        "name": "卖药郎",
        "atk": 3350,
        "hp": 10253.8,
        "def": 392.49,
        "spd": 112,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 125,
        "hp_pt": 90,
        "def_pt": 89,
        "total_pt": 304,
        "name_jp": "薬売り",
        "name_en": "Medicine Seller",
        "name_roma": "kusuri uri",
        "name_kana": "くすりうり",
        "id": 305,
        "no": 305
    },
    {
        "index": 82,
        "rank": "R",
        "name": "虫师",
        "atk": 2385.2,
        "hp": 14013.16,
        "def": 388.08,
        "spd": 115,
        "cri": 0.03,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 89,
        "hp_pt": 123,
        "def_pt": 88,
        "total_pt": 300,
        "name_jp": "蟲師",
        "name_en": "",
        "name_roma": "mushishi",
        "name_kana": "むしし",
        "id": 306,
        "no": 306
    },
    {
        "index": 36,
        "rank": "SR",
        "name": "猫掌柜",
        "atk": 3001.6,
        "hp": 10709.48,
        "def": 414.54,
        "spd": 118,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 112,
        "hp_pt": 94,
        "def_pt": 94,
        "total_pt": 300,
        "name_jp": "猫又",
        "name_en": "",
        "name_roma": "nekomata",
        "name_kana": "ねこまた",
        "id": 307,
        "no": 307
    },
    {
        "index": 10,
        "rank": "SSR",
        "name": "鬼灯",
        "atk": 3189.2,
        "hp": 9228.52,
        "def": 441,
        "spd": 110,
        "cri": 0.1,
        "cri_dmg": 1.6,
        "evolve": "二技能增强",
        "atk_pt": 119,
        "hp_pt": 81,
        "def_pt": 100,
        "total_pt": 300,
        "name_jp": "鬼灯",
        "name_en": "Hozuki",
        "name_roma": "hoozuki",
        "name_kana": "ほおずき",
        "id": 308,
        "no": 308
    },
    {
        "index": 35,
        "rank": "SR",
        "name": "阿香",
        "atk": 3162.4,
        "hp": 10595.56,
        "def": 401.31,
        "spd": 114,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 118,
        "hp_pt": 93,
        "def_pt": 91,
        "total_pt": 302,
        "name_jp": "お香",
        "name_en": "Oko",
        "name_roma": "okou",
        "name_kana": "おこう",
        "id": 309,
        "no": 309
    },
    {
        "index": 81,
        "rank": "R",
        "name": "蜜桃&芥子",
        "atk": 2063.6,
        "hp": 12418.28,
        "def": 485.1,
        "spd": 110,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "解锁二技能",
        "atk_pt": 77,
        "hp_pt": 109,
        "def_pt": 110,
        "total_pt": 296,
        "name_jp": "マキ＆芥子",
        "name_en": "Maki & Karashi",
        "name_roma": "maki & karashi",
        "name_kana": "まき＆からし",
        "id": 310,
        "no": 310
    },
    {
        "index": 9,
        "rank": "SSR",
        "name": "面灵气",
        "atk": 3242.8,
        "hp": 10139.88,
        "def": 396.9,
        "spd": 119,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 121,
        "hp_pt": 89,
        "def_pt": 90,
        "total_pt": 300,
        "name_jp": "面霊気",
        "name_en": "",
        "name_roma": "menreiki",
        "name_kana": "めんれいき",
        "id": 311,
        "no": 311
    },
    {
        "index": 8,
        "rank": "SSR",
        "name": "鬼切",
        "atk": 3350,
        "hp": 10823.4,
        "def": 352.8,
        "spd": 117,
        "cri": 0.11,
        "cri_dmg": 1.6,
        "evolve": "二技能增强",
        "atk_pt": 125,
        "hp_pt": 95,
        "def_pt": 80,
        "total_pt": 300,
        "name_jp": "鬼切",
        "name_en": "Onikiri",
        "name_roma": "onikiri",
        "name_kana": "おにきり",
        "id": 312,
        "no": 312
    },
    {
        "index": 7,
        "rank": "SSR",
        "name": "犬夜叉",
        "atk": 2974.8,
        "hp": 11393,
        "def": 392.49,
        "spd": 114,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 111,
        "hp_pt": 100,
        "def_pt": 89,
        "total_pt": 300,
        "name_jp": "犬夜叉",
        "name_en": "Inuyasha",
        "name_roma": "inuyasha",
        "name_kana": "いぬやしゃ",
        "id": 313,
        "no": 313
    },
    {
        "index": 6,
        "rank": "SSR",
        "name": "杀生丸",
        "atk": 3323.2,
        "hp": 10025.96,
        "def": 388.08,
        "spd": 118,
        "cri": 0.12,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 124,
        "hp_pt": 88,
        "def_pt": 88,
        "total_pt": 300,
        "name_jp": "殺生丸",
        "name_en": "Sesshomaru",
        "name_roma": "sesshoumaru",
        "name_kana": "せっしょうまる",
        "id": 314,
        "no": 314
    },
    {
        "index": 2,
        "rank": "SP",
        "name": "少羽大天狗",
        "atk": 3484,
        "hp": 9684.2,
        "def": 374.85,
        "spd": 122,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 130,
        "hp_pt": 85,
        "def_pt": 85,
        "total_pt": 300,
        "name_jp": "少羽大天狗",
        "name_en": "",
        "name_roma": "shouu ootengu",
        "name_kana": "しょううおおてんぐ",
        "id": 315,
        "no": 315
    },
    {
        "index": 5,
        "rank": "SSR",
        "name": "白藏主",
        "atk": 1822.4,
        "hp": 14241,
        "def": 471.87,
        "spd": 111,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 68,
        "hp_pt": 125,
        "def_pt": 107,
        "total_pt": 300,
        "name_jp": "白蔵主",
        "name_en": "",
        "name_roma": "hakuzousu",
        "name_kana": "はくぞうす",
        "id": 316,
        "no": 316
    },
    {
        "index": 34,
        "rank": "SR",
        "name": "人面树",
        "atk": 1795.6,
        "hp": 12987.88,
        "def": 511.56,
        "spd": 98,
        "cri": 0.08,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 67,
        "hp_pt": 114,
        "def_pt": 116,
        "total_pt": 297,
        "name_jp": "人面樹",
        "name_en": "",
        "name_roma": "ninmenju",
        "name_kana": "にんめんじゅ",
        "id": 317,
        "no": 317
    },
    {
        "index": 33,
        "rank": "SR",
        "name": "於菊虫",
        "atk": 2948,
        "hp": 11962.6,
        "def": 374.85,
        "spd": 109,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "三技能增强",
        "atk_pt": 110,
        "hp_pt": 105,
        "def_pt": 85,
        "total_pt": 300,
        "name_jp": "お菊虫",
        "name_en": "",
        "name_roma": "okikumushi",
        "name_kana": "おきくむし",
        "id": 318,
        "no": 318
    },
    {
        "index": 4,
        "rank": "SSR",
        "name": "桔梗",
        "atk": 3108.8,
        "hp": 10595.56,
        "def": 401.31,
        "spd": 115,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 116,
        "hp_pt": 93,
        "def_pt": 91,
        "total_pt": 300,
        "name_jp": "桔梗",
        "name_en": "",
        "name_roma": "kikyou",
        "name_kana": "ききょう",
        "id": 319,
        "no": 319
    },
    {
        "index": 32,
        "rank": "SR",
        "name": "一反木绵",
        "atk": 2733.6,
        "hp": 11734.76,
        "def": 418.95,
        "spd": 118,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 102,
        "hp_pt": 103,
        "def_pt": 95,
        "total_pt": 300,
        "name_jp": "一反木綿",
        "name_en": "",
        "name_roma": "ittanmomen",
        "name_kana": "いったんもめん",
        "id": 320,
        "no": 320
    },
    {
        "index": 31,
        "rank": "SR",
        "name": "入殓师",
        "atk": 3028.4,
        "hp": 9342.44,
        "def": 463.05,
        "spd": 104,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "evolve": "二技能增强",
        "atk_pt": 113,
        "hp_pt": 82,
        "def_pt": 105,
        "total_pt": 300,
        "name_jp": "納棺師",
        "name_en": "",
        "name_roma": "noukanshi",
        "name_kana": "のうかんし",
        "id": 321,
        "no": 321
    },
    {
        "index": 1,
        "rank": "SP",
        "name": "炼狱茨木童子",
        "atk": 3323.2,
        "hp": 10253.8,
        "def": 379.26,
        "spd": 112,
        "cri": 0.15,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 124,
        "hp_pt": 90,
        "def_pt": 86,
        "total_pt": 300,
        "name_jp": "煉獄茨木童子",
        "name_en": "",
        "name_roma": "rengoku ibarakidouji",
        "name_kana": "れんごくいばらきどうじ",
        "id": 322,
        "no": 322
    },
    {
        "index": 80,
        "rank": "R",
        "name": "天井下",
        "atk": 2251.2,
        "hp": 11962.6,
        "def": 489.51,
        "spd": 109,
        "cri": 0.05,
        "cri_dmg": 1.5,
        "atk_pt": 84,
        "hp_pt": 105,
        "def_pt": 111,
        "total_pt": 300,
        "name_jp": "天井下り",
        "name_en": "",
        "name_roma": "tenjoukudari",
        "name_kana": "てんじょうくだり",
        "id": 323,
        "no": 323
    },
    {
        "index": 3,
        "rank": "SSR",
        "name": "八岐大蛇",
        "atk": 4073.6,
        "hp": 12418.28,
        "def": 480.69,
        "spd": 118,
        "cri": 0.1,
        "cri_dmg": 1.5,
        "atk_pt": 152,
        "hp_pt": 109,
        "def_pt": 109,
        "total_pt": 370,
        "name_jp": "オロチ",
        "name_en": "",
        "name_roma": "orochi",
        "name_kana": "おろち",
        "id": 325,
        "no": 325
    },
    {
        "index": 138,
        "rank": "N",
        "name": "盗墓小鬼",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "墓荒らしの霊",
        "name_en": "Grave Digger",
        "name_roma": "hakaarashi no rei",
        "name_kana": "はかあらしのれい",
        "id": 400,
        "no": 400
    },
    {
        "index": 137,
        "rank": "N",
        "name": "寄生魂",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "寄生霊",
        "name_en": "Parasite",
        "name_roma": "kiseirei",
        "name_kana": "きせいれい",
        "id": 401,
        "no": 401
    },
    {
        "index": 136,
        "rank": "N",
        "name": "唐纸伞妖",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "からかさ小僧",
        "name_en": "Umbrella",
        "name_roma": "karakasa kozou",
        "name_kana": "からかさこぞう",
        "id": 403,
        "no": 403
    },
    {
        "index": 135,
        "rank": "N",
        "name": "天邪鬼绿",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "天邪鬼緑",
        "name_en": "Green Imp",
        "name_roma": "amanojaku midori",
        "name_kana": "あまのじゃくみどり",
        "id": 404,
        "no": 404
    },
    {
        "index": 134,
        "rank": "N",
        "name": "天邪鬼赤",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "天邪鬼赤",
        "name_en": "Red Imp",
        "name_roma": "amanojaku aka",
        "name_kana": "あまのじゃくあか",
        "id": 405,
        "no": 405
    },
    {
        "index": 133,
        "rank": "N",
        "name": "天邪鬼黄",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "天邪鬼黄",
        "name_en": "Yellow Imp",
        "name_roma": "amanojaku ki",
        "name_kana": "あまのじゃくき",
        "id": 406,
        "no": 406
    },
    {
        "index": 132,
        "rank": "N",
        "name": "天邪鬼青",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "天邪鬼青",
        "name_en": "Blue Imp",
        "name_roma": "amanojaku ao",
        "name_kana": "あまのじゃくあお",
        "id": 407,
        "no": 407
    },
    {
        "index": 131,
        "rank": "N",
        "name": "帚神",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "箒神",
        "name_en": "Hakakigami",
        "name_roma": "houkikami",
        "name_kana": "ほうきかみ",
        "id": 408,
        "no": 408
    },
    {
        "index": 130,
        "rank": "N",
        "name": "涂壁",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "ぬりかべ",
        "name_en": "Nurikabe",
        "name_roma": "nurikabe",
        "name_kana": "ぬりかべ",
        "id": 409,
        "no": 409
    },
    {
        "index": 129,
        "rank": "N",
        "name": "大天狗呱",
        "atk": 2465.6,
        "hp": 10025.96,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 92,
        "hp_pt": 88,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "大天狗蛙",
        "name_en": "Ootengu Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 414,
        "no": 414
    },
    {
        "index": 128,
        "rank": "N",
        "name": "酒吞呱",
        "atk": 2438.8,
        "hp": 10139.88,
        "def": 401.31,
        "spd": 99,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 91,
        "hp_pt": 89,
        "def_pt": 91,
        "total_pt": 271,
        "name_jp": "酒呑蛙",
        "name_en": "Shuten Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 415,
        "no": 415
    },
    {
        "index": 127,
        "rank": "N",
        "name": "荒川呱",
        "atk": 2492.4,
        "hp": 10253.8,
        "def": 388.08,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 93,
        "hp_pt": 90,
        "def_pt": 88,
        "total_pt": 271,
        "name_jp": "荒川蛙",
        "name_en": "Arakawa Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 416,
        "no": 416
    },
    {
        "index": 126,
        "rank": "N",
        "name": "阎魔呱",
        "atk": 2278,
        "hp": 10481.64,
        "def": 396.9,
        "spd": 102,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 85,
        "hp_pt": 92,
        "def_pt": 90,
        "total_pt": 267,
        "name_jp": "閻魔蛙",
        "name_en": "Enma Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 417,
        "no": 417
    },
    {
        "index": 125,
        "rank": "N",
        "name": "两面佛呱",
        "atk": 2438.8,
        "hp": 10253.8,
        "def": 379.26,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 91,
        "hp_pt": 90,
        "def_pt": 86,
        "total_pt": 267,
        "name_jp": "両面仏蛙",
        "name_en": "Ryomen Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 418,
        "no": 418
    },
    {
        "index": 124,
        "rank": "N",
        "name": "小鹿男呱",
        "atk": 2331.6,
        "hp": 10595.56,
        "def": 396.9,
        "spd": 101,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 87,
        "hp_pt": 93,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "シシオ蛙",
        "name_en": "Shishio Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 419,
        "no": 419
    },
    {
        "index": 123,
        "rank": "N",
        "name": "茨木呱",
        "atk": 2412,
        "hp": 10253.8,
        "def": 396.9,
        "spd": 100,
        "cri": 0.01,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 90,
        "def_pt": 90,
        "total_pt": 270,
        "name_jp": "茨木蛙",
        "name_en": "Ibaraki Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 420,
        "no": 420
    },
    {
        "index": 122,
        "rank": "N",
        "name": "青行灯呱",
        "atk": 2385.2,
        "hp": 10253.8,
        "def": 401.31,
        "spd": 101,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 89,
        "hp_pt": 90,
        "def_pt": 91,
        "total_pt": 270,
        "name_jp": "青行灯蛙",
        "name_en": "Aoandon Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 421,
        "no": 421
    },
    {
        "index": 121,
        "rank": "N",
        "name": "妖刀姬呱",
        "atk": 2465.6,
        "hp": 10253.8,
        "def": 379.26,
        "spd": 99,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 92,
        "hp_pt": 90,
        "def_pt": 86,
        "total_pt": 268,
        "name_jp": "妖刀姫蛙",
        "name_en": "Yoto Hime Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 422,
        "no": 422
    },
    {
        "index": 120,
        "rank": "N",
        "name": "一目连呱",
        "atk": 2358.4,
        "hp": 10367.72,
        "def": 401.31,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 88,
        "hp_pt": 91,
        "def_pt": 91,
        "total_pt": 270,
        "name_jp": "一目連蛙",
        "name_en": "Ichimokuren Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 423,
        "no": 423
    },
    {
        "index": 119,
        "rank": "N",
        "name": "花鸟卷呱",
        "atk": 2331.6,
        "hp": 10481.64,
        "def": 396.9,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 87,
        "hp_pt": 92,
        "def_pt": 90,
        "total_pt": 269,
        "name_jp": "花鳥風月蛙",
        "name_en": "Hana Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 424,
        "no": 424
    },
    {
        "index": 118,
        "rank": "N",
        "name": "辉夜姬呱",
        "atk": 2304.8,
        "hp": 10253.8,
        "def": 405.72,
        "spd": 98,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 86,
        "hp_pt": 90,
        "def_pt": 92,
        "total_pt": 268,
        "name_jp": "かぐや姫蛙",
        "name_en": "Kaguya Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 425,
        "no": 425
    },
    {
        "index": 117,
        "rank": "N",
        "name": "荒呱",
        "atk": 2438.8,
        "hp": 10253.8,
        "def": 392.49,
        "spd": 99,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 91,
        "hp_pt": 90,
        "def_pt": 89,
        "total_pt": 270,
        "name_jp": "荒蛙",
        "name_en": "Susabi Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 426,
        "no": 426
    },
    {
        "index": 116,
        "rank": "N",
        "name": "彼岸花呱",
        "atk": 2412,
        "hp": 10139.88,
        "def": 401.31,
        "spd": 100,
        "cri": 0,
        "cri_dmg": 1.5,
        "evolve": "-",
        "atk_pt": 90,
        "hp_pt": 89,
        "def_pt": 91,
        "total_pt": 270,
        "name_jp": "彼岸花蛙",
        "name_en": "Higanbana Frog",
        "name_roma": "",
        "name_kana": "",
        "id": 427,
        "no": 427
    }
];
